/// <amd-module name="Feed/Legacy/Protocols/Components/PackagePerson" />
import * as React from "react";

import * as Utils_String from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";

import * as PackageResources from "Feed/Common/Resources";
import { CustomerIntelligenceHelper } from "Feed/Legacy/Helpers/CustomerIntelligenceHelper";
import { isSafeProtocol } from "Feed/Legacy/Helpers/UrlHelper";
import { IPerson } from "Feed/Legacy/Protocols/Common/IPerson";
import { CiConstants } from "Feed/Legacy/Protocols/Constants/Constants";
import { htmlEncode } from "Feed/Legacy/Utils/Html";

export interface IPersonProps {
    pageContext: IVssPageContext;
    person: IPerson;
}

export class PackagePerson extends React.PureComponent<IPersonProps> {
    public render(): JSX.Element {
        if (!this.props.person) {
            return null;
        }

        const isUrlSafe =
            this.props.person.url &&
            (isSafeProtocol(this.props.person.url) || this.props.person.url.indexOf(":") === -1);
        const additionalInfo = this.props.person.email || isUrlSafe;

        return (
            <div className={"person package-attribute-item" + (additionalInfo ? " additional-info" : "")}>
                <span className={"package-attribute-item-icon bowtie-icon bowtie-user"} />
                <div className="person-text">{this.props.person.name}</div>
                {additionalInfo && (
                    <div className="person-hover">
                        {this.props.person.email && (
                            <a
                                className="person-email"
                                href={"mailto:" + htmlEncode(this.props.person.email)}
                                rel="noopener noreferrer"
                                onClick={() => this._registerLinkClick(CiConstants.PersonEmailLinkClicked)}
                                aria-label={Utils_String.format(
                                    "{0}: {1}",
                                    PackageResources.Email,
                                    this.props.person.email
                                )}
                            >
                                <span className="bowtie-icon bowtie-mail-message" />
                                <span className="person-text">{PackageResources.Email}</span>
                            </a>
                        )}
                        {isUrlSafe && (
                            <a
                                className="person-url"
                                href={htmlEncode(this.props.person.url)}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => this._registerLinkClick(CiConstants.PersonUrlLinkClicked)}
                                aria-label={Utils_String.format(
                                    "{0}: {1}",
                                    PackageResources.Website,
                                    this.props.person.url
                                )}
                            >
                                <span className="bowtie-icon bowtie-globe" />
                                <span className="person-text">{PackageResources.Website}</span>
                            </a>
                        )}
                    </div>
                )}
            </div>
        );
    }

    private _registerLinkClick(feature: string) {
        CustomerIntelligenceHelper.publishEvent(this.props.pageContext, feature);
    }
}
